<template>
    <div class="greybox">
        <h1 v-if="stageTitle">{{stageTitle}}</h1>
        <p>Forgotten your password or having trouble logging in to your account? Enter your email address below and we’ll send you a new password. 
          If you have not received an email please check your junk/spam folders and add the following email address to your safe senders list: <br /><br />{{getMasterInfo.resetPasswordEmail}}</p>
        <p>Please be aware that the email address {{getMasterInfo.resetPasswordEmail}} is not monitored by our Claims Team.  If you wish to contact us, please use the details on the <router-link to="contact" class="reset-link">Contact Us</router-link> page.</p>
        <label for="username">Username / Email</label>
        <input type="text" id="username" name="username" placeholder="" v-model="username" class="reviewInputs">
        <div
            v-if="submitted && !username"
            class="text-danger">
            <small>Please enter your username / email address</small>
        </div>
        <div v-if="getErrorMessage !== ''" class="errors">{{getErrorMessage}}</div>
        <button class="button" @click="handleSubmit()" :disabled="disabled">Reset password</button>
    </div>
</template>

<script>

import base from '@/mixins/base'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'resetpassword',
  mixins: [
    base
  ],
  data () {
    return {
      username: '',
      submitted: false,
      disabled: false
    }
  },
  watch: {
    username(newVal, oldVal) {
      if(newVal === '' && newVal != oldVal) {
        this.disabled = false
        this.resetErrorMessage()
      }
    },
    'getErrorMessage': function (val) {
      if (val === 'Please check the details entered.')
        this.disabled = false
    }
  },
  computed: {
    ...mapGetters({
      getErrorMessage: 'authentication/getErrors',
      getMasterInfo: 'reseller/getMasterInfo',
    }),
    stageTitle() {
      return this.$textManager.getText("title", this.$route.name)
    }
  },
  created () {
    // reset login status
    this.$store.dispatch('authentication/logout')
  },
  methods: {
    ...mapActions({
      resetErrorMessage: 'authentication/resetErrorMessage'
    }),
    handleSubmit (e) {
      this.submitted = true
      const { resellerId, username } = this
      const { dispatch } = this.$store
      this.resetErrorMessage()
      if (username) {
        this.disabled = true;
        dispatch('authentication/resetPassword', { resellerId, username })
      }
    }
  }
}
</script>

<style>
.errors {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  margin-bottom: 16px;
}
</style>

